import { ASSETS } from "@/lib/brand";

const HOME_VALUE_URL = "https://valery.ca?ref=stefaniew";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden">
      <div className="container-edit grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="md:col-span-7 relative z-10">
          <div className="overline mb-6" data-testid="hero-overline">— Based in Ottawa · Est. Primo Group</div>
          <h1
            data-testid="hero-title"
            className="font-serif-heading text-[3.2rem] leading-[0.95] md:text-[6rem] md:leading-[0.92] text-charcoal tracking-tight"
          >
            Stefanie<br />
            <span className="italic text-bronze-deep font-light">Winstan.</span>
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-8 max-w-xl text-base md:text-lg text-ink leading-relaxed"
          >
            Realtor. Creator. Model. Entrepreneur.<br />
            CFO of Primo Group Real Estate, content creator for lifestyle brands,
            UGC &amp; on-camera talent — one doorway to everything I do.
          </p>
          <div className="mt-10 flex flex-wrap gap-4" data-testid="hero-ctas">
            <a
              href={ASSETS.homeValueUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              data-testid="hero-cta-valuation"
            >
              Find Your Home's Value
            </a>
            <a href="#create" className="btn-outline" data-testid="hero-cta-work-with-me">
              Work With Me
            </a>
          </div>
          <div className="mt-14 flex items-center gap-8 text-[11px] uppercase tracking-[0.22em] text-mute">
            <div><span className="block text-2xl font-serif-heading text-charcoal">CFO</span>Primo Group</div>
            <div className="h-10 w-px bg-charcoal/15" />
            <div><span className="block text-2xl font-serif-heading text-charcoal">4+</span>Creative Verticals</div>
            <div className="hidden sm:block h-10 w-px bg-charcoal/15" />
            <div className="hidden sm:block"><span className="block text-2xl font-serif-heading text-charcoal">OTT</span>Ottawa &amp; Surrounding</div>
          </div>
        </div>

        <div className="md:col-span-5 relative" data-testid="hero-portrait-wrap">
          <div className="absolute -top-10 -right-6 md:-right-12 text-[10px] uppercase tracking-[0.22em] text-bronze-deep rotate-90 origin-top-right hidden md:block">
            Issue N°01 — Personal Brand
          </div>
          <div className="relative border border-charcoal/10 bg-cream">
            <img
              src={ASSETS.hero}
              alt="Stefanie Winstan portrait"
              className="w-full h-[520px] md:h-[680px] object-cover object-center grayscale"
              data-testid="hero-portrait-img"
            />
            <div className="absolute left-0 bottom-0 bg-ivory border-t border-r border-charcoal/15 px-5 py-3">
              <p className="overline" data-testid="hero-badge">Stefanie W. · 2026</p>
            </div>
          </div>
        </div>
      </div>
      <div className="pointer-events-none absolute left-0 right-0 bottom-0 h-px bg-charcoal/10" />
    </section>
  );
};

export default Hero;
